/* tslint:disable */
/* eslint-disable */
/**
 * OasisExplorer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountEscrowRatio
 */
export interface AccountEscrowRatio {
    /**
     * 
     * @type {string}
     * @memberof AccountEscrowRatio
     */
    account_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountEscrowRatio
     */
    account_name?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountEscrowRatio
     */
    escrow_ratio?: number;
}

export function AccountEscrowRatioFromJSON(json: any): AccountEscrowRatio {
    return AccountEscrowRatioFromJSONTyped(json, false);
}

export function AccountEscrowRatioFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountEscrowRatio {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_id': !exists(json, 'account_id') ? undefined : json['account_id'],
        'account_name': !exists(json, 'account_name') ? undefined : json['account_name'],
        'escrow_ratio': !exists(json, 'escrow_ratio') ? undefined : json['escrow_ratio'],
    };
}

export function AccountEscrowRatioToJSON(value?: AccountEscrowRatio | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_id': value.account_id,
        'account_name': value.account_name,
        'escrow_ratio': value.escrow_ratio,
    };
}


